import axios from 'axios';

import { mapLocalStylingToApiModel } from 'styling/api/dataMapper/surveyStylingDataMapper';
import defaultStyles from 'styling/config/defaultSurveyStyles';

import { SURVEY_TYPE_COLLECTION_PATH } from '../config/EntityCollectionPathMap';
import { buildApiV2Url } from '../utils/apiUtils';
import { generateApiError } from '../utils/apiErrorMessages';
import { mapSurveyFromJsonApiModel } from '../dataMapper/surveyDataMapper';
import createSurveySubmissionErrors from '../submissionErrors/createSurveySubmissionErrors';

const createSurvey = () =>
  axios
    .post(buildApiV2Url(SURVEY_TYPE_COLLECTION_PATH), {
      default_styles_snapshot: mapLocalStylingToApiModel(defaultStyles),
    })
    .catch(
      generateApiError({ submissionErrorMap: createSurveySubmissionErrors }),
    )
    .then(response => mapSurveyFromJsonApiModel(response.data));

export default createSurvey;
